import React from 'react';
import { Card } from 'react-bootstrap';

/**
 * Sidebar context for corporate vs personal vault first-time setup (paired with init form column).
 * Shows "(Personal)" in the title for the personal vault setup flow.
 */
const INIT_INFO_POINTS = [
  'Master key is only visible to you – never communicated or stored over the internet.',
  'You can change your master key anytime with one click.',
  'Credentials are stored with two levels of encryption.',
  'Additional authentication on top of flowdo access.',
  'Encryption is using your master password – even flowdo team cannot access the credentials.',
  'All your passwords will be lost if you lose your master password.',
];

export default function CredentialVaultInitInfoPanel({ scope = 'corporate' }) {
  const title = scope === 'personal'
    ? 'Master Key (Personal) and vault security'
    : 'Master Key and vault security';

  return (
    <Card className="user-list-card credential-vault-init-info-card h-100">
      <Card.Body className="credential-vault-init-info-card__body">
        <h2 className="credential-vault-init-info-card__title">{title}</h2>
        <p className="credential-vault-init-info-card__intro text-muted small mb-3">
          A quick overview before you choose your passphrase.
        </p>
        <ul className="credential-vault-init-info-card__list mb-0">
          {INIT_INFO_POINTS.map((text) => (
            <li key={text} className="credential-vault-init-info-card__item">
              {text}
            </li>
          ))}
        </ul>
      </Card.Body>
    </Card>
  );
}
